const StrainIcon = ({ strainType }) => {
    switch (strainType) {
        case 'HYBRID':
        case 'INDICA_HYBRID':
        case 'SATIVA_HYBRID':
            return (
                <span className='headless-strain-icon strain-hybrid'>
                    <strong>Hybrid</strong>
                </span>
            );
        case 'INDICA':
            return (
                <span className='headless-strain-icon strain-indica'>
                    <strong>Indica</strong>
                </span>
            );
        case 'SATIVA':
            return (
                <span className='headless-strain-icon strain-sativa'>
                    <strong>Sativa</strong>
                </span>
            );
        case 'HIGH_CBD':
            return <span className='headless-strain-icon strain-cbd'><strong>CBD</strong></span>;
        default:
            return null;
    }
};

export default StrainIcon;
